import { type Product, useProductStore } from "@/stores/products.ts";
import { useProfileStore } from "@/stores/profile.ts";
import { useCartStore } from "@/stores/cart.ts";

export function itemsPluralizedGenitive(itemsNumber: number) {
  if (itemsNumber === 1) {
    return "1 položka";
  }
  if (itemsNumber === 2 || itemsNumber === 3 || itemsNumber === 4) {
    return `${itemsNumber} položky`;
  } else {
    return `${itemsNumber} položek`;
  }
}

export function itemsPluralizedAccusative(itemsNumber: number) {
  if (itemsNumber === 1) {
    return "1 položku";
  }
  if (itemsNumber === 2 || itemsNumber === 3 || itemsNumber === 4) {
    return `${itemsNumber} položky`;
  } else {
    return `${itemsNumber} položek`;
  }
}

export function itemsPluralizedNominativeWillBeAdjusted(itemsNumber: number) {
  if (itemsNumber === 1) {
    return "1 položka bude upravena";
  }
  if (itemsNumber === 2 || itemsNumber === 3 || itemsNumber === 4) {
    return `${itemsNumber} položky budou upraveny`;
  } else {
    return `${itemsNumber} položek bude upraveno`;
  }
}

export function formatPrice(price: number, withCurrency = true) {
  return price.toFixed(2).replace(".", ",") + (withCurrency ? " Kč" : "");
}

export function productInPackMode(product: Product) {
  return product.packMode && product.unit2 === "bal" && (product.unit2Factor ?? 0) > 0;
}

export function getPackSize(product: Product) {
  if (product.unit2 === "bal" && (product.unit2Factor ?? 0) > 0) {
    return `${product.unit2} = ${product.unit2Factor}${product.unit}`;
  }
  return "";
}

export function getProductQuantityStep(product: Product) {
  if (productInPackMode(product)) {
    return product.unit2Factor ?? 1;
  }
  return 1; // Default step for products not in pack mode
}

export function productOrderUnit(product: Product) {
  return product.unit;
}

export function formatUnit(product: Product) {
  return product.unit;
}

export async function initializeAuthenticatedStores() {
  console.log("Initializing authenticated stores");
  const productStore = useProductStore();
  const profileStore = useProfileStore();
  const cartStore = useCartStore();
  await profileStore.initialize();
  await productStore.initialize();
  await cartStore.initialize();
}

// Format date (assuming the date is in ISO format)
export const formatDateTime = (dateString: string) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("cs-CZ", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatDate = (dateString: string) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("cs-CZ", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

export const MINIMUM_PASSWORD_LENGTH = 6;
